/** Client Tolgee Content Delivery fallback timing (ms). */
export const TOLGEE_CDN_FETCH_TIMEOUT_MS = 5000;
